// This plugin helps preload the auth routes client-side to prevent 404 errors

export default defineNuxtPlugin(async (nuxtApp) => {
  // Re-enabled since we found the issue was in redirect-logger
  const ROUTE_LOADER_DISABLED = false;
  
  if (ROUTE_LOADER_DISABLED) {
    console.log('[ROUTE-LOADER] Plugin is temporarily disabled for debugging');
    return;
  }

  // List of routes to preload
  const authRoutes = ['/auth/forgot-password', '/auth/reset-password']
  
  // Get current route
  const route = useRoute()
  
  // Track if we've already processed this route to prevent loops
  let routeProcessed = false
  
  // If user is on an auth route, ensure the page is properly loaded
  if (authRoutes.includes(route.path) && !routeProcessed) {
    console.log(`Current route ${route.path} is an auth route, ensuring it's properly loaded`)
    routeProcessed = true
    
    // Additional initialization if needed
    if (process.client) {
      // Force component update when on client side
      nextTick(() => {
        console.log('Forcing client-side update for auth route')
      })
    }
  }
}) 